@if (loginService.loggedIn.value) {
  @let fragment = this.fragment();
  <div class="flex flex-wrap justify-content-evenly gap-1 action-list" aria-label="Action list">
    @for (button of buttonList; track $index) {
      @if (button.enabled) {
        @switch (button.value) {
          @case ('quote') {
            @if (fragment.privacy !== 10 && fragment.privacy !== 1 && fragment.privacy !== 2) {
              <button
                [disabled]="!fragment.canQuote"
                [matTooltip]="'post-actions.quotePost' | translate"
                mat-button
                (click)="quotePost()"
                class="mat-circle-button quote-icon"
              >
                <fa-icon size="lg" [icon]="quoteIcon"></fa-icon>
              </button>
            }
          }
          @case ('rewoot') {
            @if (myRewootsIncludePost()) {
              <button
                [matTooltip]="'post-actions.deleteRewootPost' | translate"
                mat-button
                (click)="deleteRewoots()"
                class="mat-circle-button delete-rewoot-icon"
                [disabled]="loadingRewoot"
              >
                <fa-icon size="lg" [icon]="closeIcon"></fa-icon>
              </button>
            } @else if (fragment.privacy !== 10 && fragment.privacy !== 1) {
              <button
                [matTooltip]="'post-actions.rewootPost' | translate"
                [disabled]="!fragment.canReblog"
                mat-button
                (click)="$event.stopPropagation()"
                (mousedown)="startReblog($event)"
                (mouseup)="endReblog($event)"
                class="relative mat-circle-button rewoot-icon"
                [disabled]="loadingRewoot"
              >
                <fa-icon size="lg" [icon]="quickReblogIcon"></fa-icon>
                <button #reblogMenuOpener [mat-menu-trigger-for]="reblogMenu" class="menu-toggle-hidden"></button>
              </button>
              <mat-menu #reblogMenu="matMenu">
                @for (account of accountList(); track $index) {
                  <button mat-menu-item (click)="quickReblog($index, $event)">
                    <div class="user-info"
                      ><img [src]="toAvatarUrl(account.blog)" class="user-avatar" />
                      <span [innerHTML]="account.blog.url" class="user-name"></span
                    ></div>
                  </button>
                }
              </mat-menu>
            }
          }
          @case ('reply') {
            <button
              [matTooltip]="'post-actions.replyPost' | translate"
              [disabled]="!fragment.canReply"
              mat-button
              (click)="replyPost()"
              class="mat-circle-button reply-icon"
            >
              <fa-icon size="lg" [icon]="reblogIcon"></fa-icon>
            </button>
          }
          @case ('bookmark') {
            @if (bookmarked()) {
              <button
                [matTooltip]="'post-actions.unbookmarkPost' | translate"
                mat-button
                (click)="unbookmarkPost()"
                class="mat-circle-button unbookmark-icon"
                [disabled]="loadingBookmark"
              >
                <fa-icon size="lg" [icon]="unbookmarkIcon"></fa-icon>
              </button>
            } @else {
              <button
                [matTooltip]="'post-actions.bookmarkPost' | translate"
                mat-button
                (click)="bookmarkPost($event)"
                class="mat-circle-button bookmark-icon"
                [disabled]="loadingBookmark"
              >
                <fa-icon size="lg" [icon]="bookmarkIcon"></fa-icon>
              </button>
            }
          }
          @case ('like') {
            @if (fragment.userId !== myId) {
              @if (fragment.userLikesPostRelations.includes(myId)) {
                <button
                  [matTooltip]="'post-actions.dislikePost' | translate"
                  mat-button
                  (click)="unlikePost()"
                  class="mat-circle-button unlike-icon"
                  [disabled]="loadingLike"
                >
                  <fa-icon size="lg" [icon]="clearHeartIcon"></fa-icon>
                </button>
              } @else {
                <button
                  [matTooltip]="'post-actions.likePost' | translate"
                  [disabled]="!fragment.canLike"
                  mat-button
                  (click)="likePost($event)"
                  class="mat-circle-button like-icon"
                  [disabled]="loadingLike"
                >
                  <fa-icon size="lg" [icon]="solidHeartIcon"></fa-icon>
                </button>
              }
            }
          }
          @case ('edit') {
            @if (fragment.userId === myId) {
              <button
                [matTooltip]="'post-actions.editPost' | translate"
                mat-button
                (click)="editPost(fragment)"
                class="mat-circle-button edit-woot-icon"
              >
                <fa-icon size="lg" [icon]="editedIcon"></fa-icon>
              </button>
            }
          }
          @case ('delete') {
            @if (fragment.userId === myId) {
              <button
                [matTooltip]="'post-actions.deletePost' | translate"
                mat-button
                (click)="deletePost(fragment.id)"
                class="mat-circle-button delete-woot-icon"
              >
                <fa-icon size="lg" [icon]="deleteIcon"></fa-icon>
              </button>
            }
          }
        }
      }
    }
  </div>
}
